const enableTabViewEvent = () => {
  console.log("[enableTabViewEvent]");
  if (typeof window === "undefined") {
    console.warn("tabview event can't be listened on node environment.");
    return;
  }
  window.KakaoPay.webTabNavigationClick = (evt) => {
    console.log("[webTabNavigationClick]");
    const tabClickEvent = new CustomEvent("tab_click", {
      detail: evt
    });
    document.dispatchEvent(tabClickEvent);
  };
  window.KakaoPay.webTabSwipeEnd = (evt) => {
    console.log("[webTabSwipeEnd]");
    const tabSwipeEvent = new CustomEvent("tab_swipe_end", {
      detail: evt
    });
    document.dispatchEvent(tabSwipeEvent);
  };
  window.KakaoPay.webTabSelected = (evt) => {
    console.log("[webTabSelected]");
    const tabSelectedEvent = new CustomEvent("tab_selected", {
      detail: evt
    });
    document.dispatchEvent(tabSelectedEvent);
    if (evt.is_selected) {
      document.dispatchEvent(new Event("resume"));
    } else {
      document.dispatchEvent(new Event("pause"));
    }
  };
};
export {
  enableTabViewEvent
};
